import { GameCanvas } from '@/components/game/GameCanvas';
import { LandscapeOverlay } from '@/components/ui/LandscapeOverlay';

const Index = () => {
  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden bg-background">
      <GameCanvas />
      <LandscapeOverlay />
    </div>
  );
};

export default Index;
